import React from 'react'
import { Box, type SxProps, type Theme, Typography } from '@mui/material'

import { Icon } from '~components/internal'
import { lightTheme } from '~createTheme'

interface TextInfoProps {
  message: string
  backgroundColor?: string
  textColor?: string
  iconColor?: string
  maxWidth?: string | number
  sx?: SxProps<Theme>
}

const TextInfo: React.FC<TextInfoProps> = ({
  message,
  backgroundColor = 'var(--lightoffwhite)',
  textColor = lightTheme.palette.text.primary,
  iconColor = lightTheme.palette.primary.main,
  maxWidth = '600px',
  sx,
}) => {
  return (
    <Box
      sx={{
        backgroundColor,
        borderRadius: 2,
        padding: 1,
        marginY: 2,
        display: 'flex',
        alignItems: 'center',
        maxWidth,
        width: '100%',
        ...sx,
      }}
    >
      <Icon name='info' fill={0} color={iconColor} style={{ marginRight: 8, flexShrink: 0 }} />
      <Typography variant='body2' color={textColor} sx={{ justifyContent: 'center' }}>
        {message}
      </Typography>
    </Box>
  )
}

export default TextInfo
